import { render, staticRenderFns } from "./parmFile.vue?vue&type=template&id=c76b5fae&scoped=true&"
import script from "./parmFile.vue?vue&type=script&lang=js&"
export * from "./parmFile.vue?vue&type=script&lang=js&"
import style0 from "./parmFile.vue?vue&type=style&index=0&id=c76b5fae&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c76b5fae",
  null
  
)

export default component.exports